import React, { FunctionComponent } from 'react';

import { SettingsEnableDisable } from '@components/settings/shared/settings-enable-disable';

interface AllowCollectionGuestAssetCroppingProps {
  defaultEnabled: boolean | null;
}

const AllowCollectionGuestAssetCropping: FunctionComponent<AllowCollectionGuestAssetCroppingProps> = ({ defaultEnabled }) => (
  <SettingsEnableDisable
    defaultEnabled={defaultEnabled === null ? true : defaultEnabled}
    errorTitle={bfTranslate('Error updating allow guests to crop assets. Please contact support.')}
    id="allow-collection-guest-asset-cropping"
    successTitle={bfTranslate('Allow guests to crop assets updated!')}
    title={bfTranslate('Allow guests to crop assets')}
    updateResourceKey="allowCollectionGuestAssetCropping"
  />
);

export default AllowCollectionGuestAssetCropping;
